import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { LoanChecklist, TenantChecklistResponse } from '../loans/types';
import { checklistMockData } from '../utils/checklist.mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface GetLoanChecklistParams {
  loanId: string;
}

const _mockData = checklistMockData();

const getTenantChecklist: QueryFunction<
  LoanChecklist[],
  ['/tenant/checklist']
> = async () => {
  if (isMockServices()) return await mock(_mockData);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<TenantChecklistResponse>(
    '/checklist-rules',
    {
      method: 'GET',
    },
  );

  if (response.data) return response.data.checklistRules ?? [];

  throw new Error('Failed to fetch loan checklist');
};

export default getTenantChecklist;
